import React from 'react'
import { SupportPlayer, supportPlayerName } from '../../hooks/supportplayer/useOrgSupportPlayers'
import { IRecruiter } from './CampaignTable'

interface RecruitedSupportersRowProps {
  recruiter: IRecruiter
  supportersById: Map<string, SupportPlayer>
  colSpan: number
}

// Expanded row listing which supporters are registered under a participant
const RecruitedSupportersRow: React.FC<RecruitedSupportersRowProps> = ({
  recruiter,
  supportersById,
  colSpan,
}) => {
  const allRecruited = recruiter.recruited_users.filter((r) => !!r.user_id)
  // Supporters missing from the org's supporter list no longer have an active agreement.
  // Skip the filter until that list has loaded.
  const recruitedUsers = supportersById.size
    ? allRecruited.filter((r) => supportersById.has(r.user_id))
    : allRecruited
  const endedCount = allRecruited.length - recruitedUsers.length

  return (
    <tr className='bg-light'>
      <td colSpan={colSpan} className='ps-10 py-3'>
        {endedCount > 0 && (
          <div className='text-muted fs-8 mb-2'>
            {endedCount} støttespiller{endedCount === 1 ? '' : 'e'} uten aktiv avtale vises ikke
          </div>
        )}
        {recruitedUsers.length === 0 ? (
          <span className='text-muted fs-7'>Ingen støttespillere på denne deltageren ennå</span>
        ) : (
          <table className='table table-sm mb-0 gs-0 gy-1'>
            <thead>
              <tr className='fw-bold text-muted fs-8'>
                <th className='text-uppercase'>Støttespiller</th>
                <th className='text-uppercase'>E-post</th>
                <th className='text-uppercase'>Registrert</th>
                <th className='text-uppercase'>Motatt støtte</th>
              </tr>
            </thead>
            <tbody>
              {recruitedUsers.map((recruitedUser, index) => {
                const supporter = supportersById.get(recruitedUser.user_id)
                return (
                  // A supporter can be registered twice under the same participant
                  // eslint-disable-next-line react/no-array-index-key
                  <tr key={`${recruitedUser.user_id}-${index}`} className='fs-7'>
                    <td className='text-dark fw-bold'>
                      {supportPlayerName(supporter) || 'Anonym'}
                    </td>
                    <td className='text-muted'>{supporter?.email || '-'}</td>
                    <td className='text-muted'>
                      {recruitedUser.recruited_on
                        ? new Date(recruitedUser.recruited_on).toLocaleDateString('nb-NO')
                        : '-'}
                    </td>
                    <td className='text-muted'>{recruitedUser.total_amount || 0}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        )}
      </td>
    </tr>
  )
}

export default React.memo(RecruitedSupportersRow)
